export default __webpack_public_path__ + "static/Corprate_WhoWeAre_03-a45752b30303a1801ca4332c92511bfc.jpg";